import React, { useEffect } from "react";
import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";

function FixedSobre(props) {
  return (
    <Box className="sobre maincontent">
      <div className="sobre_content" >
        <h2 className="heading">Sobre</h2>
        <div>
          <p>Somos uma associação mato-grossense que tem por objetivo oferecer assessoria técnica em arquitetura, urbanismo e engenharia para a parcela da população com renda de até 3 salários mínimos, contribuindo para assegurar o Direito à Moradia Digna.</p>
        </div>
        <div >
          <p><strong>Missão |</strong> Contribuir para a melhoria do Habitat urbano através da assessoria técnica.</p>
          <p><strong>Visão |</strong> Ser uma organização reconhecida pela contribuição na melhoria do habitat urbano em Mato Grosso.</p>
          <p><strong>Valores |</strong> Valorização das pessoas; ética; responsabilidade social; respeito à diversidade; sustentabilidade; autonomia.</p>
        </div>
        <div className="sobre_buttons">
          <Link to="/posts" ><Button variant="outlined" className="sobre_button">Acesse nosso blog</Button></Link>
          <Link to="/transparencia" ><Button variant="outlined" className="sobre_button">Transparência</Button></Link>
          <Link to="/pagina/contribua" ><Button variant="outlined" className="sobre_button">Contribua</Button></Link>
        </div>
      </div>
    </Box>
  )
}

export default function Sobre(props) {
    useEffect(() => {
        document.title = 'Modular - ATHIS';
      }, []);
  return (
      <FixedSobre />
  );
}